var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "provider-primary-contact-info-form" },
    [
      _c("section-title", {
        staticClass: "mb-2",
        attrs: { "has-line": false, title: "Información de Contacto Primario" }
      }),
      _c("contact-information", {
        staticClass: "pl-3",
        attrs: { "civil-statuses": _vm.civilStatuses },
        model: {
          value: _vm.contactInfoModel,
          callback: function($$v) {
            _vm.contactInfoModel = $$v
          },
          expression: "contactInfoModel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }